if (!customElements.get('code-cart-item')) {
  customElements.define(
    'code-cart-item',
    class CodeCartItem extends HTMLElement {
    connectedCallback() {
      const sectionId = this.closest('code-cart-form').getAttribute('data-section-id');

      this.unsubscribe = subscribe('cartUpdate', ({ sections = {} }) => {
        const section = sections[sectionId];

        if (section) {
          const newCartItem = new DOMParser()
            .parseFromString(section, 'text/html')
            .querySelector(`${this.tagName.toLowerCase()}[data-key="${this.dataset.key}"]`);

          if (newCartItem) {
            const { details: [details] = [] } = codeGetTargets(this);
            const { details: [newDetails] = [] } = codeGetTargets(newCartItem);

            details.replaceWith(newDetails);
          }
        }

        this.toggleAttribute('data-loading', false);
      });
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }
  });
}
